import { connect } from 'react-redux'
import ExamCard from 'components/Card/ExamCard'
import MockCarousel from 'components/carousel/MockCarousel'
import SampleTestCard from 'components/Card/SampleTestCard'
import { Col, Container, Row } from 'reactstrap'
import useGetApi from '../../api/useGetApi'
import CONFIG from '../../config'
import MockExamLocked from '../Card/MockExamLocked'
import { SunspotLoader } from 'react-awesome-loaders'
import { useEffect } from 'react'
import MoreInfoSection from 'components/MoreInfoSection/MoreInfoSection'
import ResultAwaitedCase from 'components/Card/ResultAwaitedCase'
import TestServerDownMsg from 'components/Card/TestServerDownMsg'
import Branchmapsection from 'components/branchDetails/branch_map_section'
import RegistartionSteps from 'components/RegistrationSteps/RegistartionSteps'

const mapStateToProps = (state) => ({
    profileInfo: state?.profileData,
    dashboardInfo: state?.dashboardData
})

function ScholarshipTest(props) {
    const {fetchDashboardData, dashboarderror} = props
    
    useEffect(() => {
        if (
            props?.updateDetailsResponse &&
            props?.updateDetailsResponse?.success &&
            props?.updateDetailsResponse?.success === 'true'
        ) {
            fetchDashboardData(true)
        }

        // eslint-disable-next-line
    }, [props])

    if (props?.dashApiLoading) {
        return (
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)',
                }}
            >
                <SunspotLoader
                    gradientColors={['#6366F1', '#E0E7FF']}
                    shadowColor={'#3730A3'}
                    desktopSize={'30px'}
                    mobileSize={'20px'}
                />
            </div>
        )
    }

    const { main_exam, sample_exam, mock_exam, static_data } = props?.dashboardInfo;

    return (
        <>
        {(dashboarderror || props?.dashboardInfo?.success === 'false') ? 
        <div>Error: {dashboarderror ? dashboarderror.message : props?.dashboardInfo?.msg}</div> 
        : <Container className="p-3 pb-lg-0 pb-xl-3 bg-light vh-90 vh-lg-100 mw-100 mh-100">
            {/* ANTHE MAIN EXAM CARD */}

            {static_data.testplayer_down ? (
                <TestServerDownMsg msg={static_data.dashboard_msg} />
            ) : main_exam[0]?.result_expected_date ? (
                <ResultAwaitedCase
                    cardData={main_exam[0]}
                    staticData={static_data}
                    profileData={props?.profileInfo}
                />
            ) : (
                <ExamCard
                    fetchDashboardData={fetchDashboardData}
                    fetchProfileData={props?.fetchProfileData}
                    cardData={main_exam[0]}
                    staticData={static_data}
                    profileData={props?.profileInfo}
                />
            )}

            {/* Mock Card Locked div */}
            {!static_data.mock_purchased && (
                <Row>
                    <Col sm={12} md={4} className="my-3">
                        {sample_exam.map((cardDetails, index) => (
                            <SampleTestCard
                                key={index}
                                cardData={cardDetails}
                                profileData={props?.profileInfo}
                                heading={static_data.sample_heading}
                                style={{
                                    width: '100%',
                                    filter: 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))',
                                }}
                            />
                        ))}
                    </Col>
                    <Col sm={12} md={8} className="my-0 my-md-3">
                        <MockExamLocked profileData={props?.profileInfo} />
                    </Col>
                </Row>
            )}

            {/* Mock carousel when mock purchased */}
            {props?.dashboardInfo?.static_data.mock_purchased &&
            mock_exam.length > 0 ? (
                <Row className="mt-3">
                    <Col
                        sm={12}
                        md={5}
                        lg={4}
                        className="mb-3 mt-lg-0 mb-lg-3 my-xl-0 px-3 pe-lg-0"
                    >
                        {sample_exam.map((cardDetails, index) => (
                            <SampleTestCard
                                key={index}
                                cardData={cardDetails}
                                profileData={props?.profileInfo}
                                heading={static_data.sample_heading}
                                style={{
                                    width: '100%',
                                    filter: 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))',
                                }}
                            />
                        ))}
                    </Col>
                    <Col sm={12} md={12} lg={8}>
                        <MockCarousel
                            response={mock_exam}
                            staticData={static_data}
                        />
                    </Col>
                </Row>
            ) : null}

            <MoreInfoSection profileData={props?.profileInfo} token={props?.token} isResultAwaited={static_data.testplayer_down || main_exam[0]?.result_expected_date ? true : false} />
        </Container>}
        </>
    )
}

export default connect(mapStateToProps)(ScholarshipTest)
